import React from 'react';
import axios from '../axios';
import Loader from '../loader';
import ModalContentBaseXl from '../redux/components/modal/modal_content_base_xl';
import moment from 'moment';
import AboutPaymentModal from '../redux/components/event/about_payment_modal';
import CirclesPlans from './circles_plans';

const SectionPlansCompaniesCircles = ({
  eventId,
  // reservationSystemFee,
  eventsPlans,
  setEventsPlans,
  isNew,
  isCompanyOwnedCircle,
  circlesPlans,
  noCreditErrorMsg,
  // setNoCreditErrorMsg,
  hasPayjp,
  openCreditcardModal,
}) => {
  const [isCreating, setIsCreating] = React.useState(false);
  const [editableEventsPlanIds, setEditableEventsPlanIds] = React.useState([]);

  const initialEventsPlan = {
    id: '',
    event_id: eventId,
    plan: '参加チケット',
    target_type: 2,
    capacity: 0,
    price: 0,
    creator_price: 0,
    price_type: 99,
    role_type: 0,
    description: '',
    expired_at: null,
    is_reservation_fee_paid_by_participants: false,
    is_application_allowed: true,
    circles_plans_events_plans: [],
    first_participant_discount_rate: 0,
  };

  const addEventsPlan = React.useCallback(() => {
    setIsCreating(true);
    axios
      .post('/api/event_edit/create_events_plan', initialEventsPlan)
      .then((response) => {
        setEventsPlans((prev) => [...prev, response.data]);
        setEditableEventsPlanIds((prev) => [...prev, response.data.id]);
      })
      .finally(() => {
        setIsCreating(false);
      });
  });

  const removeEventsPlan = React.useCallback(
    (planId, index) => {
      axios
        .post('/api/event_edit/delete_events_plan', {
          event_id: eventId,
          id: planId,
        })
        .then(() => {
          setEventsPlans((prev) => {
            const newEventsPlans = [...prev];
            newEventsPlans.splice(index, 1);
            return newEventsPlans;
          });
        });
    },
    [eventId]
  );

  return (
    <section id="plans">
      <div className="container col-md-8 col-lg-6">
        <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
          コミュニティイベント参加チケット設定
          {noCreditErrorMsg && (
            <span className="text-danger text-fz-small ml-2">
              {noCreditErrorMsg}
              <span className="text-info" onClick={() => openCreditcardModal()}>
                登録はこちらから
              </span>
            </span>
          )}
        </p>
      </div>
      <div className={`container col-md-8 col-lg-6`}></div>
      {eventsPlans.map((eventsPlan, index) => (
        <EventsPlanBox
          key={eventsPlan.id}
          eventsPlan={eventsPlan}
          setEventsPlan={(plan) => {
            setEventsPlans((prev) => {
              const newEventsPlans = [...prev];
              newEventsPlans[index] = plan;
              return newEventsPlans;
            });
          }}
          removeEventsPlan={() => {
            removeEventsPlan(eventsPlan.id, index);
          }}
          isEditable={editableEventsPlanIds.includes(eventsPlan.id) || isNew}
          // reservationSystemFee={reservationSystemFee}
          hasPayjp={hasPayjp}
          isRemovable={eventsPlans.length > 1 && eventsPlan.is_removable}
          isCompanyOwnedCircle={isCompanyOwnedCircle}
          circlesPlans={circlesPlans}
          // setNoCreditErrorMsg={setNoCreditErrorMsg}
          // checkHasCredit={() => {
          //   if (
          //     eventsPlans.every(
          //       (p) => p.is_reservation_fee_paid_by_participants
          //     ) ||
          //     hasPayjp
          //   )
          //     setNoCreditErrorMsg('');
          // }}
        />
      ))}
      {isCreating ? (
        <Loader isActive={isCreating} />
      ) : (
        <div className="container col-md-8 col-lg-6 p-0">
          <div className="d-flex justify-content-end mr-1">
            <button
              className="bg-white mt-1 border border-dark"
              onClick={() => addEventsPlan()}
            >
              <p className="text-fz-14px text-black-333 text-fw-normal m-1">
                ＋ チケットの追加
              </p>
            </button>
          </div>
        </div>
      )}
    </section>
  );
};
const EventsPlanBox = ({
  eventsPlan,
  setEventsPlan,
  removeEventsPlan,
  isEditable,
  reservationSystemFee,
  hasPayjp,
  isRemovable,
  isCompanyOwnedCircle,
  circlesPlans,
  // setNoCreditErrorMsg,
  // checkHasCredit: _checkHasCredit,
}) => {
  const [isCreditcardErrorOn, setIsCreditcardErrorOn] = React.useState(
    !hasPayjp && !eventsPlan.is_reservation_fee_paid_by_participants
  );
  const modalRef = React.useRef();

  const updateEventsPlan = React.useCallback(() => {
    axios.post('/api/event_edit/update_events_plan', eventsPlan);
    // checkHasCredit();
  }, [eventsPlan]);

  let eventsPriceType = eventsPlan.price_type;

  if (eventsPlan.creator_price > 0 && eventsPlan.price_type == 99) {
    eventsPriceType = 3;
  } else if (eventsPlan.creator_price == 0 && eventsPlan.price_type != 99) {
    eventsPriceType = 99;
  } else {
    eventsPriceType = eventsPriceType;
  }

  return (
    <div className="mb-2">
      <div className="shadow-sm mb-0 bg-white">
        <div className="container col-md-8 col-lg-6 p-3_5 border-bottom">
          <div className="row justify-content-between p-1">
            <p className="col-4 pr-2 m-0">チケット名</p>
            <input
              id="plan"
              className="col-8 p-0 w-100 textarea--eventreport text-right"
              value={eventsPlan.plan}
              onBlur={updateEventsPlan}
              onChange={(e) =>
                setEventsPlan({ ...eventsPlan, plan: e.target.value })
              }
              placeholder="参加チケット"
            />
          </div>
        </div>
      </div>
      <div className="shadow-sm mb-0 bg-white">
        <div className="container col-md-8 col-lg-6 border-bottom p-3_5">
          <div className="row justify-content-between p-1">
            <p className="col-4 pr-2 m-0">参加料金</p>
            <div className="col-8 d-flex justify-content-end">
              <input
                id="creator_price"
                className="p-0 textarea--eventreport text-right"
                type="number"
                min="0"
                defaultValue={0}
                onBlur={updateEventsPlan}
                onChange={(e) => {
                  const priceType =
                    Number(e.target.value) === 0
                      ? 99
                      : eventsPriceType === 99
                      ? 3
                      : eventsPriceType;
                  setEventsPlan({
                    ...eventsPlan,
                    price: Number(e.target.value),
                    creator_price: Number(e.target.value),
                    price_type: Number(priceType),
                  });
                }}
                placeholder={0}
                style={{ width: '160px' }}
                disabled={!isEditable}
              />
              <span className="p-0 text-right">円</span>
            </div>
          </div>
        </div>
        <div className=" container col-md-8 col-lg-6 border-bottom p-3_5">
          <div className="row justify-content-between p-1">
            <p className="col-4 pr-2 m-0">決済方法</p>
            {isEditable /* selectタグだとiOSで画面が泳ぐので場合分け */ ? (
              <select
                id="price_type"
                value={eventsPriceType}
                onBlur={updateEventsPlan}
                onChange={(e) => {
                  setEventsPlan({
                    ...eventsPlan,
                    price_type: Number(e.target.value),
                  });
                }}
                className="col-8 p-0 textarea--eventreport text-gray text-right"
                style={{ overflow: 'hidden' }}
                disabled={true}
              >
                {/* <option value={99}>無料 *TOPや検索一覧に表示されません</option> */}
                <option value={3}>事前決済（クレジット / Amazon Pay）</option>
                {/* <option value={1}>現地決済 *TOPや検索一覧に表示されません</option> */}
              </select>
            ) : (
              <span className="col-8 p-0 textarea--eventreport text-gray text-right">
                {eventsPlan.price_type == 99
                  ? '無料 *TOPや検索一覧に表示されません'
                  : eventsPlan.price_type == 3
                  ? '事前決済（クレジット / Amazon Pay）'
                  : eventsPlan.price_type == 1
                  ? '現地決済 *TOPや検索一覧に表示されません'
                  : ''}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="shadow-sm mb-3 bg-white">
        <div className="container col-md-8 col-lg-6 p-3_5">
          <div className="row d-flex justify-space-between">
            <div className="col-7">
              {isRemovable && (
                <button
                  className="bg-white mt-1 w-100 border border-dark"
                  onClick={() => removeEventsPlan()}
                >
                  <p className="text-fz-14px text-black-333 text-fw-normal m-1">
                    ー チケットの削除
                  </p>
                </button>
              )}
            </div>
            <div className="col-5">
              <ModalContentBaseXl
                ref={modalRef}
                previewContent={
                  <p className="p-0 text-primary text-right bg-white border-0 m-1">
                    詳細設定する
                  </p>
                }
                modalContent={
                  <PlanDetailsSettingModal
                    closeModal={() => modalRef.current.closeModal()}
                    eventsPlan={eventsPlan}
                    setEventsPlan={setEventsPlan}
                    isCompanyOwnedCircle={isCompanyOwnedCircle}
                    isEditable={isEditable}
                    circlesPlans={circlesPlans}
                    updateEventsPlan={updateEventsPlan}
                    isCreditcardErrorOn={isCreditcardErrorOn}
                  />
                }
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const PlanDetailsSettingModal = ({
  closeModal,
  eventsPlan,
  setEventsPlan,
  isCompanyOwnedCircle,
  isEditable,
  circlesPlans,
  updateEventsPlan,
}) => {
  React.useEffect(() => {
    if (window.innerWidth >= 768) {
      $('.datetimepicker').each(function () {
        $(this).datetimepicker({
          format: 'Y/m/d H:i',
          lang: 'ja',
          scrollInput: true,
          timepicker: true,
          step: 5,
        });
      });
    }
  }, []);

  let datetimeFormType;
  let datetimeFormat;
  if (window.innerWidth >= 768) {
    datetimeFormType = 'text';
    datetimeFormat = 'YYYY/MM/DD HH:mm';
    $('.datetimepicker').each(function () {
      $(this).datetimepicker({
        format: 'Y/m/d H:i',
        lang: 'ja',
        scrollInput: true,
        timepicker: true,
        step: 5,
      });
    });
  } else {
    datetimeFormType = 'datetime-local';
    datetimeFormat = 'YYYY-MM-DDTHH:mm';
  }

  return (
    <div className="card bg-gray" style={{ paddingBottom: '144px' }}>
      <div
        className="bg-white w-100 border-bottom"
        style={{
          zIndex: 9998,
          borderRadius: '16px 16px 0 0',
          position: 'fixed',
        }}
      >
        <button
          type="button"
          className="close close__modal position--modalclose"
          aria-label="Close"
          onClick={() => closeModal()}
        >
          <span className="text-fz-24px float-right m-2" aria-hidden="true">
            ×
          </span>
        </button>
      </div>
      <div className="bg-white h-100">
        <main
          style={{ paddingBottom: '180px' }}
          className="bg-gray h-main100vh"
        >
          <div className="container col-md-8 col-lg-6 pt-5">
            <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-0 d-inline-block">
              プラン名
            </p>
            <p className="text-fz-small text-black-50 mb-2">
              早期に申し込むとお得になる「早割」プランの活用は有効です。申込期限や人数で区切って早割りプランを作りましょう。
            </p>
          </div>
          <div className="shadow-sm mb-0 bg-white">
            <div className=" container col-md-8 col-lg-6 p-3_5">
              <input
                id="plan"
                className="p-0 w-100 textarea--eventreport"
                value={eventsPlan.plan}
                onBlur={() => updateEventsPlan()}
                onChange={(e) =>
                  setEventsPlan({ ...eventsPlan, plan: e.target.value })
                }
                placeholder="プラン名を入力(例：イベント+飲み会）"
              />
            </div>
          </div>
          {isCompanyOwnedCircle && (
            <React.Fragment>
              <div className="container col-md-8 col-lg-6">
                <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 mr-3 d-inline-block">
                  役割 ※つなげーと公式イベント限定設定
                </p>
              </div>
              <div className="shadow-sm mb-0 bg-white">
                <div className=" container col-md-8 col-lg-6 p-3_5">
                  <select
                    id="role_type"
                    onBlur={() => updateEventsPlan()}
                    onChange={(e) => {
                      setEventsPlan({
                        ...eventsPlan,
                        role_type: Number(e.target.value),
                      });
                    }}
                    value={eventsPlan.role_type}
                    className="p-0 w-100 textarea--eventreport custom-select custom-select--makecircle text-dark"
                  >
                    <option value={0}>一般</option>
                    <option value={1}>ファシリテーター</option>
                    {/* <option value={2}>スタッフ</option> */}
                  </select>
                </div>
              </div>
            </React.Fragment>
          )}
          <div className="container col-md-8 col-lg-6">
            <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
              対象者
            </p>
          </div>
          <div className="shadow-sm mb-0 bg-white">
            <div className=" container col-md-8 col-lg-6 border-bottom p-3_5">
              <select
                id="target_type"
                onBlur={() => updateEventsPlan()}
                onChange={(e) => {
                  setEventsPlan({
                    ...eventsPlan,
                    target_type: Number(e.target.value),
                  });
                }}
                value={eventsPlan.target_type}
                className="p-0 w-100 textarea--eventreport custom-select custom-select--makecircle text-dark"
              >
                <option value={2}>サークルメンバー+非メンバー</option>
                <option value={1}>サークルメンバー</option>
                <option value={0}>非メンバー</option>
              </select>
            </div>
            <div className=" container col-md-8 col-lg-6 p-3_5">
              <select
                id="capacity"
                placeholder="募集人数を選択"
                onBlur={() => updateEventsPlan()}
                onChange={(e) => {
                  setEventsPlan({
                    ...eventsPlan,
                    capacity: Number(e.target.value),
                  });
                }}
                value={eventsPlan.capacity}
                className="p-0 w-100 textarea--eventreport custom-select custom-select--makecircle text-dark"
              >
                <option value={0}>人数制限なし</option>
                {[...Array(100)].map((_, i) => {
                  return (
                    <option key={i + 1} value={i + 1}>
                      {i + 1}人
                    </option>
                  );
                })}
              </select>
            </div>
          </div>

          <div className="container col-md-8 col-lg-6">
            <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 mr-3 d-inline-block">
              会費
            </p>
            <p className="text-fz-small text-black-50 mb-2">
              現地決済を設定せず、すべてのチケットが事前決済（クレジット /
              Amazon Pay）で設定されているイベントを表示上で優遇します。
            </p>
          </div>
          <div className="shadow-sm mb-0 bg-white">
            <div className="container col-md-8 col-lg-6 p-3_5">
              <select
                id="price_type"
                onBlur={() => updateEventsPlan()}
                onChange={(e) => {
                  setEventsPlan({
                    ...eventsPlan,
                    price_type: Number(e.target.value),
                  });
                }}
                value={eventsPlan.price_type}
                className="p-0 w-100 textarea--eventreport custom-select custom-select--makecircle text-dark"
                disabled={!isEditable}
              >
                {/* <option value={99}>無料 *TOPや検索一覧に表示されません</option> */}
                <option value={3}>事前決済（クレジット / Amazon Pay）</option>
                {/* <option value={1}>現地決済 *TOPや検索一覧に表示されません</option> */}
              </select>
            </div>
            {Number(eventsPlan.price_type) === 3 && (
              <div className="container col-md-8 col-lg-6 pb-3">
                <AboutPaymentModal />
              </div>
            )}
          </div>
          {circlesPlans && circlesPlans.length > 0 && (
            <CirclesPlans
              circlesPlans={circlesPlans}
              circlesPlansEventsPlans={eventsPlan.circles_plans_events_plans}
              onChangeCirclesPlans={(circlesPlansEventsPlans) => {
                setEventsPlan({
                  ...eventsPlan,
                  circles_plans_events_plans: circlesPlansEventsPlans,
                });
              }}
            />
          )}
          <div className="container col-md-8 col-lg-6">
            <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
              チケットの説明
            </p>
            <p className="text-fz-small text-black-50 mb-2">
              参加料金以外に現地で掛かる費用についてはここに記入してください。
            </p>
          </div>
          <div className="shadow-sm mb-0 bg-white">
            <div className=" container col-md-8 col-lg-6 p-3_5">
              <input
                id="description"
                className="p-0 w-100 textarea--eventreport"
                value={eventsPlan.description}
                onBlur={() => updateEventsPlan()}
                onChange={(e) => {
                  setEventsPlan({ ...eventsPlan, description: e.target.value });
                }}
                placeholder="説明が必要な場合は記入"
              />
            </div>
          </div>

          <div className="container col-md-8 col-lg-6">
            <p className="text-fz-14px text-fw-bold text-black-50 mb-2_5 mt-3 d-inline-block">
              初回参加者の割引設定
            </p>
            <p className="text-fz-small text-black-50 mb-2">
              このサークルのイベントに初めて参加する場合の割引率設定
            </p>
          </div>
          <div className="shadow-sm mb-3 bg-white">
            <div className=" container col-md-8 col-lg-6 ">
              <div className="row justify-content-between p-3_5 border-bottom">
                <select
                  id="first_participant_discount_rate"
                  onBlur={() => updateEventsPlan()}
                  onChange={(e) => {
                    const discount_rate = e.target.value;

                    if (discount_rate === '割引しない') {
                      setEventsPlan({
                        ...eventsPlan,
                        first_participant_discount_rate: 0,
                      });
                    } else {
                      setEventsPlan({
                        ...eventsPlan,
                        first_participant_discount_rate: Number(
                          discount_rate.slice(0, -1)
                        ),
                      });
                    }
                  }}
                  value={
                    !eventsPlan.first_participant_discount_rate ||
                    eventsPlan.first_participant_discount_rate === 0
                      ? '割引しない'
                      : `${eventsPlan.first_participant_discount_rate}%`
                  }
                  className="p-0 w-100 textarea--eventreport custom-select custom-select--makecircle text-dark"
                >
                  {['割引しない', '100%', '50%', '30%', '20%', '10%'].map(
                    (i) => (
                      <option value={i} key={i}>
                        {i}
                      </option>
                    )
                  )}
                </select>
              </div>
            </div>
          </div>

          <div className="container col-md-8 col-lg-6">
            <p className="text-fz-14px text-fw-bold text-black-50 mb-2_5 mt-3 d-inline-block">
              このチケットの募集締切
              <span className="text-fz-small text-fw-normal">
                　※空欄の場合は無期限
              </span>
            </p>
          </div>
          <div className="shadow-sm mb-3 bg-white">
            <div className=" container col-md-8 col-lg-6 ">
              <label
                htmlFor="expired_at"
                className="row justify-content-between p-3_5"
              >
                <p className="pr-2 mb-0">締切日時</p>
                <input
                  type={datetimeFormType}
                  className="datetimepicker form-style-reset p-0 textarea--eventreport"
                  id="expired_at"
                  value={
                    eventsPlan.expired_at
                      ? moment(eventsPlan.expired_at).format(datetimeFormat)
                      : ''
                  }
                  onBlur={(e) => {
                    setEventsPlan({
                      ...eventsPlan,
                      expired_at: e.target.value,
                    });
                  }}
                  onChange={(e) => {
                    setEventsPlan({
                      ...eventsPlan,
                      expired_at: e.target.value,
                    });
                  }}
                  placeholder="2019/08/25 10:00"
                  autoComplete="off"
                />
              </label>
              <div
                className="text-fz-small text-black-50 text-right"
                style={{ marginTop: '-10px', paddingBottom: 10 }}
              >
                <span
                  onClick={() => {
                    setEventsPlan({ ...eventsPlan, expired_at: '' });
                  }}
                >
                  日時をクリアする
                </span>
              </div>
            </div>
          </div>
          <div className="container col-md-8 col-lg-6">
            <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
              このプランの募集ステータス
            </p>
          </div>
          <div className="shadow-sm mb-0 bg-white">
            <div className=" container col-md-8 col-lg-6 p-3_5">
              <select
                id="is_application_allowed"
                onBlur={() => updateEventsPlan()}
                onChange={(e) => {
                  setEventsPlan({
                    ...eventsPlan,
                    is_application_allowed: e.target.value === 'true',
                  });
                }}
                value={eventsPlan.is_application_allowed}
                className="p-0 w-100 textarea--eventreport custom-select custom-select--makecircle text-dark"
              >
                <option value={true}>募集中</option>
                <option value={false}>募集終了</option>
              </select>
            </div>
          </div>
          <div style={{ paddingBottom: '12px' }}>
            <div className="container col-md-8 col-lg-6">
              <button
                type="button"
                className="a-button a-button__top a-button--orange w-100 mb-5 mt-5"
                onClick={() => closeModal()}
              >
                OK
              </button>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default SectionPlansCompaniesCircles;
